import { render, staticRenderFns } from "./staticTemplate.vue?vue&type=template&id=a6ab5c44&scoped=true&"
import script from "./staticTemplate.vue?vue&type=script&lang=js&"
export * from "./staticTemplate.vue?vue&type=script&lang=js&"
import style0 from "./staticTemplate.vue?vue&type=style&index=0&id=a6ab5c44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ab5c44",
  null
  
)

export default component.exports